import { useSuspenseQuery } from "@tanstack/react-query";
import { Trans } from "react-i18next";
import { MdClose } from "react-icons/md";

import { Price } from "@onsite_app/MobileOrderingMenu/Atoms";
import { useCurrentCartUuid } from "@onsite_app/MobileOrderingMenu/Pages/Session/SessionContext";

import VenueOnlineConfigQueries from "../../VenueOnlineConfig/queries";
import { useRemoveCartVoucherAssignment } from "./mutations";
import { VoucherAssignmentQueries } from "./queries";

const VoucherAssignmentsList = () => {
  const cartUuid = useCurrentCartUuid();
  const vouchersEnabled = useSuspenseQuery({
    ...VenueOnlineConfigQueries.current(),
    select: (data) => data.hasActiveVouchers,
  }).data;
  const voucherAssignments = useSuspenseQuery(
    VoucherAssignmentQueries.all(cartUuid),
  );

  const removeVoucherAssignmentMutation = useRemoveCartVoucherAssignment();

  const onRemoveAssignment = (uuid: string) => async () => {
    await removeVoucherAssignmentMutation.mutateAsync(uuid);
  };
  if (!vouchersEnabled) {
    return null;
  }
  return (
    <div className="space-y-8">
      <div className="space-y-8">
        {voucherAssignments.data.map(({ voucher, ...assignment }) => (
          <div className="flex items-center space-x-8" key={assignment.uuid}>
            <div className="flex flex-1 items-center space-x-12 rounded-venue-brand border-2 border-venue-primary bg-venue-tertiary p-8">
              <div className="flex-1">
                <div className="font-medium">
                  {voucher.voucherName || (
                    <Trans
                      i18nKey={"voucherClaim.voucherValueName"}
                      components={{
                        Value: (
                          <Price
                            value={voucher.openingBalanceInCents}
                            fromCents
                          />
                        ),
                      }}
                    />
                  )}{" "}
                  {voucher.senderName && (
                    <Trans
                      i18nKey="cart.voucherFrom"
                      values={{ name: voucher.senderName }}
                      components={{
                        Name: <span className="font-semibold" />,
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
            <div>
              <a onClick={onRemoveAssignment(assignment.uuid)}>
                <MdClose className="text-[24px]" />
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VoucherAssignmentsList;
